import React, { useState, useEffect, useRef } from 'react';
import CommonSlider from './partials/commonslider';
import { useEvents } from '../hooks/useEvents';
import EventCard from './EventCard';
import './Events.css';

const Home = () => {
  const { events, loading } = useEvents();
  const latestEvents = events.slice(0, 3);
  // Animation states for scroll-triggered animations
  const [isFacilitiesVisible, setIsFacilitiesVisible] = useState(false);
  const [isLocalExperiencesVisible, setIsLocalExperiencesVisible] = useState(false);
  
  // Refs for targeting sections
  const facilitiesRef = useRef(null);
  const localExperiencesRef = useRef(null);

  // Smooth scrolling for anchor links
  useEffect(() => {
    const handleSmoothScroll = (e) => {
      if (e.target.matches('a[href^="#"]')) {
        e.preventDefault();
        const target = document.querySelector(e.target.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  // Scroll-triggered animations using Intersection Observer
  useEffect(() => {
    const observers = [];

    // Facilities section animation
    if (facilitiesRef.current) {
      const facilitiesObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setIsFacilitiesVisible(true);
              }, 200);
              facilitiesObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );
      facilitiesObserver.observe(facilitiesRef.current);
      observers.push(facilitiesObserver);
    }

    // Local experiences section animation
    if (localExperiencesRef.current) {
      const localObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setIsLocalExperiencesVisible(true);
              }, 300);
              localObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );
      localObserver.observe(localExperiencesRef.current);
      observers.push(localObserver);
    }

    // Cleanup function
    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);


  return (
    <>
      <main>
        <CommonSlider />

        
        <div className="petti_bg">
          <div className="container margin_120_95" id="first_section">
            <div className="row justify-content-between flex-lg-row-reverse align-items-center">
              <div className="col-lg-5">
                <div className="parallax_wrapper">
            
                 
                  <img src="/assets/img/bg/intro1.webp" alt="" className="img-fluid rounded-img" />
                  
                  <div data-cue="slideInUp" className="img_over">
                    <span data-jarallax-element="-60"
                     style={{ zIndex: 0, transform: 'translate3d(0px, 20px, 0px)', position: 'relative' }}>
                      <img src="/assets/img/bg/intro2.webp" alt="" className="rounded-img" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="intro" style={{ color: '#fff' }}>
                  <div className="title">
                    <small style={{ color: '#fff' }}>RELAX, REFRESH, REPEAT</small>
                    <h3 style={{ color: '#fff', fontWeight: '500' }}>
                      SETTLING INTO THE<br />
                      <span style={{ color: '#18373b' }}>PERFECT VACATION</span><br />
                      NEVER LOOKED SO EASY...
                    </h3>
                  </div>
                  <p className="lead" style={{ color: '#fff' }}>
                    Petti Petti promises a cosy, eclectic vibrance during the day and warmly lit romantic experience into the night. We bring in the opulence and comfort which invites vacationers of all types, meshed in through our easy-going daylight hours through to the frequent lively night-time dinner dance parties that follow.
                  </p>
                  <p style={{ fontSize: '16px' }}>
                    The atmosphere remains pristine throughout the day, with a surf friendly ocean and countless cocktails in the sun. Petti Petti makes for a perfect beach date for everyone!
                  </p>
                  <h3 className="ceofont" style={{ color: '#fff' }}>
                    NISAL HETTIARCHCHI,<span style={{ color: '#18373b', fontSize: '1.5rem', fontWeight: '400' }}>
                      <br />FOUNDER
                    </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="content-section petti_cream" style={{ padding: '0px' }}>
          <div className="container-fluid" style={{ paddingLeft: '0px', paddingRight: '30px' }}>
            <div className="row" style={{ alignItems: 'stretch', minHeight: '500px', margin: 0 }}>
              {/* Left side - Large Image */}
              <div className="col-lg-6" style={{ 
                paddingRight: '15px',
                paddingLeft: '0px',
                paddingTop: '0px',
                paddingBottom: '0px'
              }}>
                <figure className="side-image" style={{ height: '100%', margin: 0 }}>
                  <img 
                    src="/assets/img/daymenu/home_sidemain.webp" 
                    alt="Day menu" 
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: '0px',
                      boxShadow: 'none',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />
                </figure>
              </div>
              
              {/* Right side - Content */}
              <div className="col-lg-6" style={{ 
                padding: '40px 40px 20px 40px',
                backgroundRepeat: 'repeat',
                backgroundSize: '60px 60px',
                paddingLeft: '15px',
                paddingRight: '40px',
                paddingTop: '40px',
                paddingBottom: '60px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start'
              }}>
                {/* Title */}
                <div className="title" style={{ marginBottom: '20px' }}>
                  <small style={{ 
                    color: '#333',
                    fontSize: '14px',
                    letterSpacing: '2px',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    marginBottom: '15px',
                    display: 'block'
                  }}>
                    Bar &amp; Restaurant
                  </small>
                </div>
                
                {/* Main Heading */}
                <h2 style={{ marginBottom: '20px' }}>
                  <span style={{ 
                    fontFamily: 'Poppins, sans-serif', 
                    fontWeight: 500, 
                    color: '#227b74', 
                    fontSize: '2.2rem',
                    lineHeight: '1.2',
                    textTransform: 'uppercase',
                    display: 'block'
                  }}>
                    WHERE THE FLAVOR INEBRIATES YOU
                  </span>
                </h2>
                
                {/* Text Content */}
                <p style={{ 
                  backgroundColor: 'transparent',
                  color: '#517874',
                  fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '30px',
                  fontWeight: '400',
                  textAlign: 'left'
                }}>
                  Savor generous sharing platters, delicious burgers, healthful salads, diverse global dishes and handcrafted cocktails. Our cuisine emphasizes crave-worthy, shareable, and delectable choices.
                </p>
                
                {/* Button */}
                <a href="/dining" className="btn_1 outline" style={{
                  backgroundColor: '#508a84',
                  color: '#fff',
                  border: 'none',
                  padding: '15px 40px',
                  borderRadius: '30px',
                  textTransform: 'uppercase',
                  fontWeight: '500',
                  fontSize: '16px',
                  letterSpacing: '1px',
                  textDecoration: 'none',
                  display: 'inline-block',
                  transition: 'all 0.3s ease',
                  marginBottom: '40px',
                  textAlign: 'center'
                }}>
                  VIEW OUR MENU
                </a>
                
                {/* Food Images */}
                <div className="row food-small inner" style={{ margin: 0, width: '100%' }}>
                  <div className="col-md-6 col-xs-6" style={{ padding: '0 10px' }}>
                    <figure className="side-image"
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      margin: 0,
                      padding: 0,
                      position: 'relative',
                    }}
                    >
                    <img 
                      className="image-size"
                      src="/assets/img/daymenu/home_side2.webp" 
                      alt="Food" 
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        margin: 0,
                        padding: 0,
                        position: 'relative',
                      }}
                    />
                    </figure>
                    
                  </div>
                  <div className="col-md-6 col-xs-6" style={{ padding: '0 10px' }}>

                  
                    <img 
                      className="image-size"
                      src="/assets/img/daymenu/home_side3.webp" 
                      alt="Food" 
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        margin: 0,
                        padding: 0,
                        position: 'relative',
                      }}
                    />
                   
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
        <div className="pinned-image pinned-image--medium" style={{ height: '75vh', width: '100%', position: 'relative', overflow: 'hidden' }} id="section_video">
  <video 
    loop 
    muted 
    autoPlay 
    playsInline 
    id="video_home"
    style={{ 
      width: '100%', 
      height: '100%', 
      objectFit: 'cover', 
      position: 'absolute',
      top: 0,
      left: 0
    }}
  >
    <source src="/assets/video/pettipettipromo.mp4" type="video/mp4" />
  </video>
  <div className="pinned-image__container-overlay" style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)', // Changed from 0.3 to 0.5 for darker overlay
    zIndex: 1
  }}></div>
  
  <div className="pinned_over_content" style={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: 'white',
    zIndex: 2,
    width: '90%',
    maxWidth: '800px'
  }}>
    <div className="title white">
      <small data-cue="slideInUp" data-delay="200">Seaside Sanctuary</small>
      <h2 data-cue="slideInUp" data-delay="300" className="partyfont" style={{ 
        fontFamily: 'Poppins, sans-serif', 
        fontStyle: 'normal',
        fontWeight: 200, 
        color: 'rgb(255, 255, 255)', 
        fontSize: '40px', 
        lineHeight: '48px'
      }}>
        Sandy toes, Coastal Cocktails,<br />Salty kisses & Culinary Delights
      </h2>
    </div>
  </div>
</div>
        

        <div className="petti_cream_rep">
          <div className="container margin_120_95">
            <div className="row justify-content-between d-flex align-items-center add_bottom_90" ref={facilitiesRef}>
              <div className="col-lg-6">
                <div className={`pinned-image rounded_container pinned-image--small mb-4 animate-scale-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.2s' }}>
                  <div>
                    <img style={{  height: '65vh' }} src="/assets/img/facilities/1.webp" alt="" />
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className={`title cream-round-box animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.1s' }}>
                  <h3>Facilities</h3>
                  <p>Indulge in seaside luxury with gourmet dining, vibrant social scenes, and an infinity pool offering breathtaking ocean vistas.</p>
                  <p><a href="/about" className="btn_1 mt-1 outline">Check out more</a></p>
                </div>
              </div>
            </div>
            <div className="row justify-content-between d-flex align-items-center" ref={localExperiencesRef}>
              <div className="col-lg-6 order-lg-2">
                <div className={`pinned-image rounded_container pinned-image--small mb-4 animate-scale-up ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.2s' }}>
                  <div>
                    <img style={{  height: '65vh' }}src="/assets/img/facilities/2.webp" alt="" />
                  </div>
                </div>
              </div>
              <div className="col-lg-5 order-lg-1">
                <div className={`title cream-round-box animate-slide-up ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.1s' }}>
                  <h3>Local Experiences</h3>
                  <p>Nestled near our resort are captivating attractions: serene beaches, lush hiking trails, historic landmarks, and vibrant local markets await exploration.</p>
                  <p><a href="/about" className="btn_1 mt-1 outline">Check out more</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="parallax_section_1 jarallax" data-jarallax data-speed="0.2">
          <img className="jarallax-img kenburns-2" src="/assets/img/events/1.webp" alt="" />
          <div className="wrapper opacity-mask d-flex align-items-center justify-content-center text-left" data-opacity-mask="rgba(0, 0, 0, 0.5)">
            <div className="container">
              <div className="row justify-content-md-start">
                <div className="col-lg-12">
                  <div className="title white">
                    <small className="mb-1">Music is in our DNA</small>
                    <h2 className="partyfont" style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 500, color: 'rgb(255, 255, 255)', fontSize: '40px', lineHeight: '52px' }}>
                      The Party Never Stops
                    </h2>
                    <p className="lead" style={{ color: "white" }}>
                      With us, our sun-down cocktails bring out the best dancers in town. Fuelled by the best DJ's, we definitely know how to throw a party. Catch us at our next one?
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="petti_cream_rep">
          <div className="container margin_80_55">
            <div className="col-12 title mb-3 text-center" style={{ paddingBottom: "10px" }}>
              <small data-cue="slideInUp">Celebrate Life</small>
              <h2 data-cue="slideInUp" data-delay="200">Upcoming Events</h2>
            </div>
            <div className="row justify-content-center home">
              {loading && (
                <div className="col-12 text-center">
                  <p className="event-status">Loading events...</p>
                </div>
              )}

              {!loading && latestEvents.length === 0 && (
                <div className="col-12 text-center">
                  <h3 className="event-status" style={{ fontSize: '30px', fontWeight: 700 }}>
                    There are no events at the moment!
                  </h3>
                </div>
              )}

              {!loading && latestEvents.map((event) => (
                <div className="col-lg-4 col-md-6 col-12 mb-4" key={event._id}>
                  <EventCard event={event} />
                </div>
              ))}
            </div>
            <p className="text-end">
              <a href="/events" className="btn_1 outline mt-2" data-cue="slideInUp" data-delay="600">
                View all Events
              </a>
            </p>
          </div>
        </div>
      </main>
      
    </>
  );
};

export default Home;
